import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "tipos_pago",
    "tipo_pago",
    "TipoPagoForm",
    "/tipos_pago",
);

export default handleActions(reducers, initialState);
